// default api limits
export const DEFAULT_OUTREACH_SENT_PAGE_SIZE: number = 20;
export const DEFAULT_EMAIL_RECIPIENT_PAGE_SIZE: number = 20;

// recipient count threshold to switch from showing individual emails to showing total count
export const SHOW_RECIPIENT_COUNT_AFTER_THRESHOLD: number = 10;
